import { render, staticRenderFns } from "./project-expert.vue?vue&type=template&id=b9fe126e&scoped=true&"
import script from "./project-expert.vue?vue&type=script&lang=js&"
export * from "./project-expert.vue?vue&type=script&lang=js&"
import style0 from "./project-expert.vue?vue&type=style&index=0&id=b9fe126e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fe126e",
  null
  
)

export default component.exports